<template>

    <div class="menulist-wrapper localechanger">
        <div class="menulist-header">
            <h3>{{ lang('all.taal_wijzigen') }}</h3>
            <div>
                <a
                    href="#"
                    @click.prevent="closeLocaleChanger"
                >
                    <i class="mdi mdi-close-box-outline"></i>
                    <span class="sr-only">{{ lang('all.sluiten') }}</span>
                </a>
            </div>
        </div>
        <div>
            <ul>
                <li
                    v-for="(locale, code) in localeData.allowed"
                >
                    <a
                        :href="route('changelocale', {locale: code})"
                    >
                        <span :class="'fi fi-' + mapLocaleToIcon(code)"></span>
                        {{ locale }}
                    </a>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>

import axios from 'axios';

export default {

    methods: {
        closeLocaleChanger() {
            this.$emit('closeLocaleChanger');
        },

        mapLocaleToIcon(locale) {
            if (locale === 'en') {
                return 'gb';
            }
            return locale;
        }
    },

    name:'ComponentLocaleChanger',

    props: {
        localeData: {
            required:true,
            type:Object,
        },
    },

}

</script>
